import React from 'react'
import * as S from './styles'
import PropTypes from 'prop-types'

const Highlight = ({ type, children }) => {
  return (
    <S.Container aria-live='polite' type={type}>
      {children}
    </S.Container>
  )
}

Highlight.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'error', 'success', 'outline']),
  children: PropTypes.node
}

export default Highlight
